import angular from 'angular';

import '../../../services/user';

angular.module('folkeuni').component('userActivate', {
  bindings: {
    loginPageUrl: '@',
    siteId: '@',
    token: '@',
    user: '@'
  },
  controller: function(User, $sce, $timeout) {
    var $ctrl = this;

    $ctrl.$onInit = function() {
      $ctrl.statusMessage = null;
      $ctrl.loading = true;
      $ctrl.success = null;
      $ctrl.error = null;
      var userObj = {
        email: $ctrl.user,
        token: $ctrl.token
      }

      User.activate(userObj).then(function(successResponse) {

        $ctrl.loading = false;
        $ctrl.success = true;
        $ctrl.statusMessage = "Din bruger er nu aktiveret og du bliver viderestillet til loginsiden.";

        $timeout(function() {
          window.location.href = $ctrl.loginPageUrl;
        }, 2000);
      }, function(errorResponse) {

        $ctrl.loading = false;
        $ctrl.error = true;
        $ctrl.statusMessage =  $sce.trustAsHtml('Vi kunne desværre ikke aktivere din bruger. <br/>Hvis du har aktiveret din profil, kan du benytte <a href="'+$ctrl.loginPageUrl+'">loginsiden</a> til at logge ind.<br/>Alternativt er du meget velkommen til at kontakt os for assistance.');
      })
    }

  },
  templateUrl: '/shop-dist/templates/user-activate.html',
  transclude: false
});
